export enum TestWorkerMessageType {
	RegisterRemoteUiPort = 'registerRemoteUiPort',
	SetDocumentBuffer = 'setDocumentBuffer',
	AddApp = 'addApp',
}
